var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.modalData
        ? _c("customModal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modalData,
                expression: "modalData",
              },
            ],
            attrs: {
              onModalClose: _vm.onModalClose,
              onModalAccept: _vm.updateNoAnswerCalls,
              modalData: _vm.modalData,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.hasFreeOrders && _vm.tableType == "freeOrders"
        ? _c("div", { staticClass: "sticky-top div_sticky_btn" }, [
            _c(
              "button",
              {
                ref: "assignButton",
                staticClass: "btn btn-success assignButton",
                on: { click: _vm.sendFreeOrders },
              },
              [
                _vm._v(
                  "\n      Назначить заявки (" +
                    _vm._s(_vm.getRunnerName()) +
                    ")\n    "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("form", { ref: "form", attrs: { action: "" } }, [
        _c(
          "table",
          { staticClass: "table table-bordered table-hover table-sm" },
          [
            _c("thead", [
              _c("tr", [
                _vm.tableType != "freeOrders"
                  ? _c("th", [
                      _c("input", {
                        staticClass: "main_checkbox",
                        attrs: { type: "checkbox" },
                        on: {
                          change: function ($event) {
                            return _vm.toggleAllCheckboxes()
                          },
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.tableType != "freeOrders" && _vm.tableType != "subOrders"
                  ? _c("th", { attrs: { width: "100" } })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "th",
                  [
                    _vm._v("\n          Номер\n          "),
                    _vm.tableType == "freeOrders" ||
                    _vm.tableType == "subOrders"
                      ? [
                          _vm._m(0),
                          _vm._v(" "),
                          _vm._m(1),
                          _vm._v(" "),
                          _vm._m(2),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("th", [_vm._v("План")]),
                _vm._v(" "),
                _c("th", [_vm._v("ФИО")]),
                _vm._v(" "),
                _c("th", [_vm._v("Адрес")]),
                _vm._v(" "),
                _c("th", [_vm._v("Комментарий")]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c("th", [_vm._v("\n          Препарат\n        ")]),
                _vm._v(" "),
                _c("th", [_vm._v("Сумма заявки")]),
                _vm._v(" "),
                _vm.tableType == "freeOrders" || _vm.tableType == "subOrders"
                  ? _c("th")
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm.tableType == "freeOrders"
                  ? _vm._l(
                      _vm.sortByField(_vm.orders, "timestamp"),
                      function (order, index2) {
                        return order.visible
                          ? _c(
                              "tr",
                              {
                                key: order.id,
                                ref: `tr_${order.id}`,
                                refInFor: true,
                                class: {
                                  selected: _vm.selectedFreeOrders[order.id],
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectFreeOrder(order.id)
                                  },
                                },
                              },
                              [
                                _c("td", { class: _vm.colors_num[order.id] }, [
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.printOrderId(order.id)
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("p", [
                                    _c("strong", [
                                      _vm._v(_vm._s(order.project)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.printnoAnswerCalls(
                                          order.num_nedozvonov
                                        )
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(order.date) +
                                      "\n            "
                                  ),
                                  !order.showRebook
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-warning btn-xs",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showRebookOptions(
                                                order.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Перенос\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  order.showRebook
                                    ? _c("div", [
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: order.rebookDate,
                                                expression: "order.rebookDate",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.$set(
                                                  order,
                                                  "rebookDate",
                                                  $event.target.multiple
                                                    ? $$selectedVal
                                                    : $$selectedVal[0]
                                                )
                                              },
                                            },
                                          },
                                          _vm._l(
                                            order.rebookDates,
                                            function (date, index) {
                                              return _c(
                                                "option",
                                                {
                                                  domProps: {
                                                    value: date.days,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(date.date) +
                                                      "\n                "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-success btn-xs w-100",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateOrder(
                                                  $event,
                                                  order.id,
                                                  "rebookOrder"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                перенести\n              "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("td", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.searchValueForReplace
                                        ? `${order.client.name}`.replace(
                                            _vm.searchValueForReplace,
                                            `<span class='search_selected'>${_vm.searchValueForReplace}</span>`
                                          )
                                        : order.client.name
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("td", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.searchValueForReplace
                                        ? `${order.address}`.replace(
                                            _vm.searchValueForReplace,
                                            `<span class='search_selected'>${_vm.searchValueForReplace}</span>`
                                          )
                                        : order.address
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "form",
                                    { on: { submit: _vm.saveComment } },
                                    [
                                      order.possible_early
                                        ? _c("p", [
                                            _vm._v("раньше при наличии"),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("input", {
                                        attrs: {
                                          type: "hidden",
                                          name: "order_id",
                                        },
                                        domProps: { value: order.id },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "textarea",
                                        {
                                          staticClass: "form-control",
                                          attrs: { name: "comment", rows: "3" },
                                          on: {
                                            change: function ($event) {
                                              return _vm.showCommentButton(
                                                order.id
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(order.comment))]
                                      ),
                                      _vm._v(" "),
                                      order.comment_btn
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-info btn-sm",
                                              attrs: { type: "submit" },
                                            },
                                            [
                                              _vm._v(
                                                "\n                Сохранить\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    class: { call_before: order.call_yestoday },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "phone_td" },
                                      [
                                        _vm._l(order.phones, function (phone) {
                                          return _c("p", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.printPhone(phone)) +
                                                "\n                "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    _vm.noAnsverPhoneCall(
                                                      order.id,
                                                      _vm.printPhone(phone)
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "icon-fa icon-fa-phone",
                                                }),
                                              ]
                                            ),
                                          ])
                                        }),
                                        _vm._v(" "),
                                        order.call_yestoday
                                          ? _c(
                                              "p",
                                              { staticClass: "bold_info" },
                                              [
                                                _vm._v(
                                                  "\n                Позвонить за день\n              "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { class: _vm.colors[order.id] },
                                  _vm._l(order.preps, function (p, index3) {
                                    return _c("div", { key: index3 }, [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(p.drug.prep) +
                                            " (" +
                                            _vm._s(p.prep) +
                                            ") - " +
                                            _vm._s(p.num) +
                                            "шт"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "flex" },
                                        [
                                          p.drug.commentsbypak
                                            ? [
                                                _c("div", [
                                                  _c("i", {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName: "v-tooltip",
                                                        value: {
                                                          content:
                                                            p.drug
                                                              .commentsbypak,
                                                          placement:
                                                            "bottom-center",
                                                          classes: ["info"],
                                                          targetClasses: [
                                                            "it-has-a-tooltip",
                                                          ],
                                                          offset: 20,
                                                          delay: {
                                                            show: 500,
                                                            hide: 300,
                                                          },
                                                        },
                                                        expression:
                                                          "{\n                          content: p.drug.commentsbypak,\n                          placement: 'bottom-center',\n                          classes: ['info'],\n                          targetClasses: ['it-has-a-tooltip'],\n                          offset: 20,\n                          delay: {\n                            show: 500,\n                            hide: 300\n                          }\n                        }",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "icon-fa icon-fa-info-circle",
                                                  }),
                                                ]),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          p.drug.computation_comment
                                            ? [
                                                _c("i", {
                                                  directives: [
                                                    {
                                                      name: "tooltip",
                                                      rawName: "v-tooltip",
                                                      value: {
                                                        content:
                                                          p.drug
                                                            .computation_comment,
                                                        placement:
                                                          "bottom-center",
                                                        classes: ["info"],
                                                        targetClasses: [
                                                          "it-has-a-tooltip",
                                                        ],
                                                        offset: 20,
                                                        delay: {
                                                          show: 500,
                                                          hide: 300,
                                                        },
                                                      },
                                                      expression:
                                                        "{\n                        content: p.drug.computation_comment,\n                        placement: 'bottom-center',\n                        classes: ['info'],\n                        targetClasses: ['it-has-a-tooltip'],\n                        offset: 20,\n                        delay: {\n                          show: 500,\n                          hide: 300\n                        }\n                      }",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "icon-fa icon-fa-home",
                                                }),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value: {
                                                    content:
                                                      _vm.printFigures(p),
                                                    placement: "bottom-center",
                                                    classes: ["info"],
                                                    targetClasses: [
                                                      "it-has-a-tooltip",
                                                    ],
                                                    offset: 20,
                                                    delay: {
                                                      show: 500,
                                                      hide: 300,
                                                    },
                                                  },
                                                  expression:
                                                    "{\n                        content: printFigures(p),\n                        placement: 'bottom-center',\n                        classes: ['info'],\n                        targetClasses: ['it-has-a-tooltip'],\n                        offset: 20,\n                        delay: {\n                          show: 500,\n                          hide: 300\n                        }\n                      }",
                                                },
                                              ],
                                              staticClass:
                                                "icon-fa icon-fa-exchange",
                                            }),
                                          ]),
                                        ],
                                        2
                                      ),
                                    ])
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.printSumm(order)) +
                                      "\n          "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  !order.showRejectMenu
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-danger btn-xs",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showRejectMenu(
                                                order.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Отказ\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  order.showRejectMenu
                                    ? _c("div", [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: order.prichina_otkaza,
                                              expression:
                                                "order.prichina_otkaza",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            placeholder: "Причина отказа",
                                            rows: "3",
                                          },
                                          domProps: {
                                            value: order.prichina_otkaza,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                order,
                                                "prichina_otkaza",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-danger btn-xs w-100",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateOrder(
                                                  $event,
                                                  order.id,
                                                  "rejectOrder"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Отказ\n              "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]
                            )
                          : _vm._e()
                      }
                    )
                  : _vm._l(
                      _vm.sortByField(_vm.orders, "ord"),
                      function (order, index2) {
                        return _c(
                          "tr",
                          {
                            key: order.id,
                            class: { back_green: order.zp > 0 },
                          },
                          [
                            _c("td", [
                              _c("input", {
                                staticClass: "select_checkbox",
                                attrs: {
                                  type: "checkbox",
                                  name: `selected[${order.id}]`,
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _vm.tableType != "freeOrders" &&
                            _vm.tableType != "subOrders"
                              ? _c("td", [
                                  _c("input", {
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "number",
                                      name: `orderLine[${order.id}]`,
                                      "vv-model": "order.ord",
                                    },
                                    domProps: { value: order.ord },
                                  }),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("td", { class: _vm.colors_num[order.id] }, [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.printOrderId(order.id)),
                                },
                              }),
                              _vm._v(" "),
                              _c("p", [
                                _c("strong", [_vm._v(_vm._s(order.project))]),
                              ]),
                              _vm._v(" "),
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.printnoAnswerCalls(order.num_nedozvonov)
                                  ),
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(order.date) +
                                    "\n            "
                                ),
                                _vm.tableType == "subOrders"
                                  ? [
                                      !order.showRebook
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-warning btn-xs",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showRebookOptions(
                                                    order.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                Перенос\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      order.showRebook
                                        ? _c("div", [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: order.rebookDate,
                                                    expression:
                                                      "order.rebookDate",
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                on: {
                                                  change: function ($event) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.$set(
                                                      order,
                                                      "rebookDate",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  },
                                                },
                                              },
                                              _vm._l(
                                                order.rebookDates,
                                                function (date, index) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      domProps: {
                                                        value: date.days,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(date.date) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-success btn-xs w-100",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.updateOrder(
                                                      $event,
                                                      order.id,
                                                      "rebookOrder"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  перенести\n                "
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("td", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.searchValueForReplace
                                    ? `${order.client.name}`.replace(
                                        _vm.searchValueForReplace,
                                        `<span class='search_selected'>${_vm.searchValueForReplace}</span>`
                                      )
                                    : order.client.name
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("td", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.searchValueForReplace
                                    ? `${order.address}`.replace(
                                        _vm.searchValueForReplace,
                                        `<span class='search_selected'>${_vm.searchValueForReplace}</span>`
                                      )
                                    : order.address
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("td", [
                              _c("form", { on: { submit: _vm.saveComment } }, [
                                order.possible_early
                                  ? _c("p", [_vm._v("раньше при наличии")])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("input", {
                                  attrs: { type: "hidden", name: "order_id" },
                                  domProps: { value: order.id },
                                }),
                                _vm._v(" "),
                                _c(
                                  "textarea",
                                  {
                                    staticClass: "form-control",
                                    attrs: { name: "comment", rows: "3" },
                                    on: {
                                      change: function ($event) {
                                        return _vm.showCommentButton(order.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(order.comment))]
                                ),
                                _vm._v(" "),
                                order.comment_btn
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-info btn-sm",
                                        attrs: { type: "submit" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                Сохранить\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { class: { call_before: order.call_yestoday } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "phone_td" },
                                  [
                                    _vm._l(order.phones, function (phone) {
                                      return _c("p", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.printPhone(phone)) +
                                            "\n                "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            on: {
                                              click: function ($event) {
                                                _vm.noAnsverPhoneCall(
                                                  order.id,
                                                  _vm.printPhone(phone)
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon-fa icon-fa-phone",
                                            }),
                                          ]
                                        ),
                                      ])
                                    }),
                                    _vm._v(" "),
                                    order.call_yestoday
                                      ? _c("p", { staticClass: "bold_info" }, [
                                          _vm._v(
                                            "\n                Позвонить за день\n              "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { class: _vm.colors[order.id] },
                              _vm._l(order.preps, function (p, index3) {
                                return _c("div", { key: index3 }, [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(p.drug.prep) +
                                        " (" +
                                        _vm._s(p.prep) +
                                        ") - " +
                                        _vm._s(p.num) +
                                        "шт"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex" },
                                    [
                                      p.drug.commentsbypak
                                        ? [
                                            _c("div", [
                                              _c("i", {
                                                directives: [
                                                  {
                                                    name: "tooltip",
                                                    rawName: "v-tooltip",
                                                    value: {
                                                      content:
                                                        p.drug.commentsbypak,
                                                      placement:
                                                        "bottom-center",
                                                      classes: ["info"],
                                                      targetClasses: [
                                                        "it-has-a-tooltip",
                                                      ],
                                                      offset: 20,
                                                      delay: {
                                                        show: 500,
                                                        hide: 300,
                                                      },
                                                    },
                                                    expression:
                                                      "{\n                          content: p.drug.commentsbypak,\n                          placement: 'bottom-center',\n                          classes: ['info'],\n                          targetClasses: ['it-has-a-tooltip'],\n                          offset: 20,\n                          delay: {\n                            show: 500,\n                            hide: 300\n                          }\n                        }",
                                                  },
                                                ],
                                                staticClass:
                                                  "icon-fa icon-fa-info-circle",
                                              }),
                                            ]),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      p.drug.computation_comment
                                        ? [
                                            _c("i", {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value: {
                                                    content:
                                                      p.drug
                                                        .computation_comment,
                                                    placement: "bottom-center",
                                                    classes: ["info"],
                                                    targetClasses: [
                                                      "it-has-a-tooltip",
                                                    ],
                                                    offset: 20,
                                                    delay: {
                                                      show: 500,
                                                      hide: 300,
                                                    },
                                                  },
                                                  expression:
                                                    "{\n                        content: p.drug.computation_comment,\n                        placement: 'bottom-center',\n                        classes: ['info'],\n                        targetClasses: ['it-has-a-tooltip'],\n                        offset: 20,\n                        delay: {\n                          show: 500,\n                          hide: 300\n                        }\n                      }",
                                                },
                                              ],
                                              staticClass:
                                                "icon-fa icon-fa-home",
                                            }),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value: {
                                                content: _vm.printFigures(p),
                                                placement: "bottom-center",
                                                classes: ["info"],
                                                targetClasses: [
                                                  "it-has-a-tooltip",
                                                ],
                                                offset: 20,
                                                delay: {
                                                  show: 500,
                                                  hide: 300,
                                                },
                                              },
                                              expression:
                                                "{\n                        content: printFigures(p),\n                        placement: 'bottom-center',\n                        classes: ['info'],\n                        targetClasses: ['it-has-a-tooltip'],\n                        offset: 20,\n                        delay: {\n                          show: 500,\n                          hide: 300\n                        }\n                      }",
                                            },
                                          ],
                                          staticClass:
                                            "icon-fa icon-fa-exchange",
                                        }),
                                      ]),
                                    ],
                                    2
                                  ),
                                ])
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.printSumm(order)) +
                                  "\n          "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.tableType == "subOrders"
                              ? _c("td", [
                                  !order.showRejectMenu
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-danger btn-xs",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.showRejectMenu(
                                                order.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Отказ\n            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  order.showRejectMenu
                                    ? _c("div", [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: order.prichina_otkaza,
                                              expression:
                                                "order.prichina_otkaza",
                                            },
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            placeholder: "Причина отказа",
                                            rows: "3",
                                          },
                                          domProps: {
                                            value: order.prichina_otkaza,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.$set(
                                                order,
                                                "prichina_otkaza",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-danger btn-xs w-100",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateOrder(
                                                  $event,
                                                  order.id,
                                                  "rejectOrder"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Отказ\n              "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ]
                        )
                      }
                    ),
              ],
              2
            ),
          ]
        ),
        _vm._v(" "),
        _vm.tableType != "freeOrders"
          ? _c(
              "div",
              { staticClass: "flex flex-padding-10" },
              [
                _vm.tableType == "subOrders" ||
                _vm.tableType == "assignedOrders"
                  ? [
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-info",
                            attrs: { type: "button", name: "resetOrders" },
                            on: {
                              click: function ($event) {
                                return _vm.updateOrders("resetOrders")
                              },
                            },
                          },
                          [_vm._v("\n            Сбросить заявки\n          ")]
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.tableType == "assignedOrders"
                  ? [
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-info",
                            attrs: { type: "button", name: "saveLineOrder" },
                            on: {
                              click: function ($event) {
                                return _vm.updateOrders("saveLineOrder")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Сохранить порядок\n          "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.localInCallTaks[_vm.runnerId]
                        ? [
                            _c("div", [
                              _c("div", { staticClass: "alert alert-info" }, [
                                _vm._v(
                                  "\n              Отправлено на прозвон: " +
                                    _vm._s(_vm.localInCallTaks[_vm.runnerId]) +
                                    "\n            "
                                ),
                              ]),
                            ]),
                          ]
                        : [
                            _c("div", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-sm btn-success",
                                  attrs: {
                                    type: "button",
                                    name: "sendToCallList",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateOrders("sendToCallList")
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              Отправить на прозвон\n            "
                                  ),
                                ]
                              ),
                            ]),
                          ],
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-success",
                            attrs: {
                              type: "button",
                              name: "setOrdersDelivered",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.updateOrders("setOrdersDelivered")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            Пометить доставленными\n          "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "column_legend" }, [
      _c("span", {
        staticStyle: {
          background: "#FCC4C4",
          width: "10px",
          height: "10px",
          border: "1px solid",
          display: "inline-block",
        },
      }),
      _vm._v("\n              не хватает\n            "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "column_legend" }, [
      _c("span", {
        staticStyle: {
          background: "#BCE2F4",
          width: "10px",
          height: "10px",
          border: "1px solid",
          display: "inline-block",
        },
      }),
      _vm._v("\n              в дороге\n            "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "column_legend" }, [
      _c("span", {
        staticStyle: {
          background: "#F9E5AE",
          width: "10px",
          height: "10px",
          border: "1px solid",
          display: "inline-block",
        },
      }),
      _vm._v("\n              не хв на все\n            "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("th", [
      _vm._v("\n          Телефон\n          "),
      _c("p", { staticClass: "column_legend" }, [
        _c("span", {
          staticStyle: {
            background: "#BCE2F4",
            width: "20px",
            height: "10px",
            border: "1px solid",
            display: "inline-block",
          },
        }),
        _vm._v(
          "\n            по возможности позвонить за день до доставки\n          "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }